<template lang="html">
    <div class="price-group-item col-sm-12">
        <div class="price-group-item-body">
            <div class="col-sm-12" v-if="selectedPrincingType && selectedPrincingType.id === PricingTypes.PerPerson">

                <div class="pricesRowHolder">
                    <div class="mt-2 mb-3 pb-3 border-bottom-medium" v-for="pricePerPerson, index in priceGroup.groupPrices" :key="index">
                        <PriceManagerRow 
                            :currentGroupNameProp="currentGroupNameProp" 
                            :priceGroup="priceGroup" 
                            :prices="prices" 
                            :pricePerPerson="pricePerPerson"
                            :disabled="disabled" 
                            :showDelete="priceGroup.groupPrices.length > 1" 
                            @delete="deletePrincingType($event)"
                            @updatedCustomInput="updatedCustomInput()"
                            :audienceTypes="groupAudienceTypesAvailable" 
                            :editingEvent="editingEvent"/>
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-sm-12">
                        <div class="mb-3 add d-flex align-items-center fs-small bold" :class="{'pointer':!disabled, 'notAllowed':disabled}" @click="addRowInThisGroup(priceGroup)">
                            <i class="ico-add fs-smallest add-circle color-1"></i> Add new price
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import extendedVSelect from '@/extends/vue-select';
import PriceManagerRow from '@/components/inventory/products/components/pricingManager/priceRow.vue';
import { priceManagerMixin } from '@/mixins/priceManager';
import { PricingTypes } from '@/enums/pricingType';

export default {
    data: function() {
        return {
            hasBackupedPricingType: null, // used to set temporary value
            audienceTypeSelected: null,
            PricingTypes
        }
    },
    mixins: [
        priceManagerMixin
    ],
    props: {
        priceGroup: {
            default: null
        },
        audienceTypeGroups: {
            default: null,
            type: Array
        },
        value:{
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        editingEvent: {
            type: Boolean,
            default: false
        },
        backupedPricingType: {
            type: Object,
            default: null
        },
        group: {
            type: Object,
            default: null
        },
        selectedPrincingType: {
            type: Object,
            default: null
        },
        currentGroupNameProp: null
    },
    mounted(){
        if (
            this.group &&
            this.group.backupGroup &&
            this.group.backupGroup.productGenderPrices
        ) {
            this.group.backupGroup.selectedPrincingType = this.group.selectedPrincingType;
        }
    },
    computed: {
        ...mapGetters([
            'getVatTypes',
            'getModal',
            'getAudienceTypeList'
        ]),
        groupActiveGenderPrices: function () {
            //** Price Group logic */
            return this.setActiveGenderPrices(this.priceGroup.groupPrices);
        },
        groupActiveGenderPricesAssociation: function () {
			return this.setActiveGenderPricesAssociation(this.priceGroup.groupPrices).filter( i => i != null );
        },
        groupAudienceTypesAvailable() {
            //** Retrun all audienceTypes without those active in this priceGroup */
            let audTypOutput = this.audienceTypes.filter(audienceItem => {
                const allActiveGenderPrices = this.groupActiveGenderPrices.concat(this.groupActiveGenderPricesAssociation);
                return !allActiveGenderPrices.find(genderPrice => {
                    if(genderPrice) {
                        return genderPrice.id == audienceItem.id;
                    } else {
                        return false;
                    }
                })
            })

            return audTypOutput;
        },
        prices:{
            get() {
                return this.value;
            },
            set(newVal) {
                this.$emit('input', newVal);
            }
        },
        taxes: function () {
            return this.getVatTypes;
        },
        audienceTypes: function () {
            return this.getAudienceTypeList;
        },
    },
    methods: {
        ...mapActions([
            'openModal',
            'updateroductEditPriceData',
            'setGroupPrices'
        ]),
        setActiveGenderPrices(audTypeObj) {
            return audTypeObj.map(genderPrice => {
                if(genderPrice.audienceTypeHelper && genderPrice.audienceType !== 500){
                    return genderPrice.audienceTypeHelper;
                } else {
                    return null;
                }
            })
        },
        setActiveGenderPricesAssociation(audTypeObj) {
            return audTypeObj.map(genderPrice => {
                if(genderPrice.audienceTypeAssossiation){
                    return genderPrice.audienceTypeAssossiationHelper;
                } else {
                    return null;
                }
            });
        },
        //** This is used if PER PERSON - Do not delete */
        addRowInThisGroup: function(currentPriceGroup) {
            if (this.disabled) {
                return false;
            }

            if (this.audienceTypeGroups.length > 0 && this.hasRepeatedTypeGroupsNames(this.audienceTypeGroups)) {
                this.$toasted.error('Please add first other Group Name!');
            } else if (this.audienceTypeGroups.length > 0 && this.hasEmptyNames(this.audienceTypeGroups)) {
                this.$toasted.error('Please add a Group Name!');
            } else {
                this.updateFlagsIfEventEdit();

                let defaultRow = {
                    refId: _.last(this.prices).id != undefined ? _.last(this.prices).id +1 +'-'+ new Date().getTime() : new Date().getTime(), //_.last(this.prices).id +1 +'-'+ new Date().getTime(), // temporary unique id for newly created, so we can identify the item to delete
                    genderPriceType: this.selectedPrincingType.id,
                    audienceType: this.groupAudienceTypesAvailable[0].id,
                    audienceTypeGroup: this.priceGroup.groupName != "null" || this.priceGroup.groupName != "undefined" ? this.priceGroup.groupName : null,
                    audienceTypeDescription: this.groupAudienceTypesAvailable[0].description,
                    audienceTypeHelper: this.groupAudienceTypesAvailable[0],
                    isExcludedFromBilling: this.selectedPrincingType.id === this.PricingTypes.PerOrder ? true : null,
                    isTaxIncludedInPrice: this.value[0].isTaxIncludedInPrice,
                    componentRuleType: 0, //fixed type by default
                    value: 0,
                    currency: '€',
                    vatType: this.taxes[0].id,
                    vatTypeHelper: this.taxes[0],
                    dependencySettings: null,
                    genderPriceDependencies: [],
                    productGenderPriceComponents: [],
                    audienceTypeOccupancy: 1
                }

                this.priceGroup.groupPrices.push(defaultRow);
                this.prices.push(defaultRow);
                this.setGroupPrices(this.prices);
                this.$forceUpdate();
            }

        },
        deletePrincingType(pricePerPerson) {
            // Emit a delete event with the priceRow to be deleted in the parent component
            this.$emit('deletepg', pricePerPerson);
        },
        updatedCustomInput() {
            this.$emit('updatedCustomInput');
        },
        updateFlagsIfEventEdit(){
            // adding a updateflag to Prices on editEvent
            // this function is in mixin.js
            if(this.editingEvent) this.eventActivateUpdateFlag('Prices');
        }
    },
    components: {
        vSelect: extendedVSelect,
        PriceManagerRow
    }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// PriceGroup.vue?433c0395